<template>
  <div class="payment-indicators-item">
    <SectionTitle class="payment-indicators-item__title" :text="`${titleName} — ${countryName}`" />
    <div v-if="getIsShowingFilters" class="payment-indicators-item__wrapper-filter">
      <div v-if="optionList.length" class="payment-indicators-item__wrapper-filter-item">
        <div class="payment-indicators-item__select">
          <label class="label-field">{{ labelSelect }}</label>
          <SelectMultiComponent v-model="balance" :options="optionList" placeholder="Выберите" modifier="rectangular" />
        </div>
      </div>
      <div v-if="yearList.length" class="payment-indicators-item__select payment-indicators-item__select_period">
        <label class="label-field">Период</label>
        <div class="payment-indicators-item__wrapper-filter-item">
          <SelectMultiComponent
            v-model="filters.start"
            :options="yearList"
            placeholder="Выберите"
            modifier="rectangular"
            :classSelect="{ error: v$.filters.$error }"
          />
          <SelectMultiComponent
            v-model="filters.end"
            :options="yearList"
            placeholder="Выберите"
            modifier="rectangular"
            :classSelect="{ error: v$.filters.$error }"
          />
        </div>

        <div class="invalid-msg" v-if="v$.filters.$error && v$.filters.end.isAfterStartDate.$invalid">
          Некорректный период
        </div>
      </div>
      <ButtonComponent
        @click="applyParameters"
        mod="gradient-bg"
        :disabled="disabledSearch"
        class="button-redesign--mobile-full"
        >Показать</ButtonComponent
      >
    </div>

    <div class="payment-indicators-item__block-graph">
      <h3 class="title title--graph-payments">Млрд $</h3>
      <div class="payment-indicators-item__inner-wrap">
        <div v-if="load" class="payment-indicators-item__loader-wrap">
          <Loader />
        </div>
        <EChartsColumnAndLine
          v-else
          layout="combined"
          :xData="categories"
          :columns="getChartColumns"
          :lines="getChartLines"
          :height="500"
          showYAxis
          mirrorYAxis
          enableZoom
          :dataLabels="{ enabledOnSeries: [] }"
          :stroke="{ width: 4 }"
          :marker="{ size: 0 }"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import { useVuelidate } from '@vuelidate/core';

  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import SectionTitle from '@/common/components/redesigned/SectionTitle/SectionTitle.vue';
  import SelectMultiComponent from '@/common/components/SelectMultiComponent.vue';

  import EChartsColumnAndLine from '@/components/ChartComponents/apacheEcharts/EChartsColumnAndLine.vue';
  import Loader from '@/components/Loader.vue';

  export default {
    name: 'PaymentIndicatorItem',
    components: {
      SelectMultiComponent,
      ButtonComponent,
      Loader,
      EChartsColumnAndLine,
      SectionTitle,
    },
    props: {
      titleName: {
        type: String,
        default: '',
      },
      countryName: {
        type: String,
        default: '',
      },
      optionList: {
        type: Array,
        default: () => [],
      },
      yearList: {
        type: Array,
        default: () => [],
      },
      balanceProps: {
        type: [Number, String],
        default: 0,
      },
      oldBalanceProps: {
        type: [Number, String],
        default: 0,
      },
      load: {
        type: Boolean,
        default: true,
      },
      seriesProps: {
        type: Array,
        default: () => [],
      },
      categories: {
        type: Array,
        default: () => [],
      },
      labelSelect: {
        type: String,
        default: 'Сальдо',
      },
    },
    data() {
      return {
        balance: '',
        oldBalance: '',
        filters: {
          start: '',
          end: '',
        },
        castFilters: {
          start: '',
          end: '',
        },
      };
    },
    computed: {
      disabledSearch() {
        return (!this.balance || this.balance === this.oldBalance) && !this.getIsChangedFilters;
      },
      getIsChangedFilters() {
        return JSON.stringify(this.castFilters) !== JSON.stringify(this.filters);
      },
      getIsShowingFilters() {
        return !!this.optionList.length || !!this.yearList.length;
      },
      getChartColumns() {
        return (this.seriesProps || [])
          .filter((seriesItem) => seriesItem?.type !== 'line' && seriesItem?.data?.length)
          .map((seriesItem) => ({
            name: seriesItem.name,
            data: seriesItem.data,
            color: seriesItem.color,
          }));
      },
      getChartLines() {
        return (this.seriesProps || [])
          .filter((seriesItem) => seriesItem?.type === 'line' && seriesItem?.data?.length)
          .map((seriesItem) => ({
            name: seriesItem.name,
            data: seriesItem.data,
            color: seriesItem.color,
          }));
      },
    },
    watch: {
      balanceProps(val) {
        this.balance = val;
      },
      oldBalanceProps(val) {
        this.oldBalance = val;
      },
    },
    mounted() {
      this.balance = this.balanceProps;
      this.oldBalance = this.oldBalanceProps;
      this.setCastFilters();
    },
    methods: {
      applyParameters() {
        this.v$.$touch();

        if (this.v$.$invalid) {
          return false;
        }

        const params = {
          balance: this.balance,
          ...this.filters,
        };
        this.$emit('applyParameters', params);
        this.setCastFilters();
        this.v$.$reset();
      },
      setCastFilters() {
        this.castFilters = JSON.parse(JSON.stringify(this.filters));
      },
      isAfterStartDate(value) {
        if (!this.filters.start || !value) return true;
        return new Date(value) >= new Date(this.filters.start);
      },
    },
    setup: () => ({ v$: useVuelidate() }),
    validations() {
      return {
        filters: {
          end: {
            isAfterStartDate: this.isAfterStartDate,
          },
        },
      };
    },
  };
</script>

<style lang="scss" scoped src="../../styles/payment-indicators-item.scss"></style>

<style lang="scss" scoped>
  .payment-indicators-item__title {
    margin-bottom: 16px;
  }
  .payment-indicators-item__select_period {
    .invalid-msg {
      position: absolute;
    }
  }
</style>
